module.exports = __webpack_public_path__ + "img/2.086c5e0d.png";